export const articles = [
  {
    id: 1,
    title: '《流浪地球3》定档2026暑期 郭帆：这次我们要去比邻星',
    excerpt: '国产科幻巨制《流浪地球3》正式宣布定档2026年暑期档，导演郭帆透露本片将讲述人类文明前往比邻星的星际旅程，视效规模将超越前作。',
    content: `备受期待的国产科幻巨制《流浪地球3》于近日正式宣布定档2026年暑期档。导演郭帆在接受采访时表示，本片将讲述人类文明在太阳系即将毁灭之际，启程前往4.2光年外比邻星的星际旅程。

"如果说第一部是'启程'，第二部是'抉择'，那么第三部就是'远征'。"郭帆这样形容三部曲的主题递进。据悉，《流浪地球3》的制作预算较前作大幅提升，特效镜头数量预计将超过3000个。

吴京、刘德华、李雪健等原班人马悉数回归，同时还有多位重量级演员加盟。影片将展现人类面对未知宇宙时的勇气与智慧，以及在这场史诗级星际旅行中的人性光辉。

值得一提的是，影片的科学顾问团队邀请了多位中科院专家参与，力求在科学设定上更加严谨。郭帆笑称："我们要让观众相信，这一切真的可能发生。"

目前影片已进入后期制作阶段，预计将于2026年7月正式与观众见面。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20production%20behind%20the%20scenes%20photo%20of%20film%20director%20discussing%20with%20actors%20on%20a%20massive%20LED%20volume%20stage%20surrounded%20by%20futuristic%20set%20pieces%20with%20spaceship%20cockpit%20and%20holographic%20displays%20warm%20studio%20lighting&width=800&height=450&seq=article-1&orientation=landscape',
    category: '电影',
    author: '影视观察员',
    date: '2026-07-28',
    readTime: '5分钟',
    tags: ['流浪地球', '科幻电影', '郭帆', '国产科幻'],
    relatedIds: [2, 5],
  },
  {
    id: 2,
    title: '《三体：黑暗森林》口碑爆棚 网友：国产科幻剧新高度',
    excerpt: '改编自刘慈欣同名小说的《三体：黑暗森林》开播即爆，豆瓣评分飙升至9.6，观众盛赞其忠实还原原著精髓的同时，在视觉呈现上达到了国际一流水平。',
    content: `改编自刘慈欣同名科幻巨著的电视剧《三体：黑暗森林》于本周正式开播，首播当日便引发全网热议，豆瓣评分一路飙升至9.6分，成为2026年评分最高的国产剧集。

该剧延续了第一季的高水准制作，在忠实还原原著"面壁计划"、"黑暗森林法则"等核心概念的同时，在视觉特效和场景搭建上实现了质的飞跃。制作团队透露，本季的特效预算占到了总制作成本的60%以上。

"水滴"探测器毁灭人类舰队的经典场景被观众称为"国产科幻剧史上最强名场面"，有网友评论道："当看到两千艘星舰在太空中被一颗水滴逐一贯穿时，那种绝望感扑面而来，这就是三体的魅力。"

演员阵容方面，张鲁一继续饰演罗辑，于和伟饰演的史强依然贡献了大量精彩表演。新加入的章北海一角由段奕宏出演，其冷峻克制的表演风格获得了原著粉的一致好评。

制片人白一骢表示："我们希望通过《三体》系列证明，中国科幻影视完全有能力达到世界一流水平。"据悉，《三体》第三部《死神永生》已在筹备中，预计2027年与观众见面。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20scene%20still%20from%20Three%20Body%20Problem%20Dark%20Forest%20showing%20a%20dramatic%20space%20battle%20with%20thousands%20of%20warships%20arranged%20in%20formation%20against%20the%20dark%20cosmic%20background%20a%20single%20teardrop-shaped%20probe%20approaching&width=800&height=450&seq=article-2&orientation=landscape',
    category: '电视剧',
    author: '剧评人小李',
    date: '2026-07-25',
    readTime: '6分钟',
    tags: ['三体', '科幻剧', '刘慈欣', '国产剧'],
    relatedIds: [1, 3],
  },
  {
    id: 3,
    title: '《庆余年2》大结局引爆热议 编剧回应：第三季已在路上',
    excerpt: '热播古装权谋剧《庆余年》第二季迎来大结局，反转剧情引爆全网讨论。编剧王倦透露第三季剧本已启动创作，承诺不会让观众等待太久。',
    content: `历时两个月的热播，《庆余年》第二季终于迎来了大结局。最后一集中，范闲身世之谜终于揭晓，一系列惊天反转让观众直呼"过瘾"的同时也留下了诸多悬念。

编剧王倦在接受采访时表示："第二季只是整个故事的中段，真正的重头戏还在后面。"他透露第三季的剧本创作已经启动，故事将围绕范闲与庆帝的终极对决展开。

张若昀饰演的范闲在第二季中展现了更加成熟复杂的演技，从初入京都的青涩少年成长为能够在朝堂博弈中运筹帷幄的谋略家。陈道明饰演的庆帝依然是全剧的演技担当，每一个眼神都充满了帝王心术的深不可测。

原著作者猫腻也通过社交媒体表达了对改编的认可："王倦老师的改编既保留了原著精神，又增加了许多精彩的原创内容，让整个故事更加丰满立体。"

《庆余年2》全季平均收视率创下国产剧年度新高，网络播放量突破200亿次。制片方表示第三季将加大制作投入，预计将于2027年初与观众见面。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20still%20frame%20showing%20a%20tense%20confrontation%20between%20two%20characters%20in%20elaborate%20historical%20costumes%20standing%20in%20a%20grand%20imperial%20hall%20with%20dragon%20pillars%20dramatic%20sidelighting%20from%20window&width=800&height=450&seq=article-3&orientation=landscape',
    category: '电视剧',
    author: '娱乐记者阿明',
    date: '2026-07-22',
    readTime: '5分钟',
    tags: ['庆余年', '古装剧', '权谋', '张若昀'],
    relatedIds: [2, 4],
  },
  {
    id: 4,
    title: '国漫崛起：《雾山五行》水墨画风征服全球观众',
    excerpt: '国产动画《雾山五行·犀川幻紫林》以极致的水墨画风和精湛的打斗场面征服了海内外观众，被外媒誉为"动画艺术的东方瑰宝"。',
    content: `当中国传统水墨画遇上现代动画技术，会碰撞出怎样的火花？《雾山五行·犀川幻紫林》给了我们一个惊艳的答案。

这部由六道无鱼动画工作室倾力打造的国产动画，自上线以来便凭借其独特的水墨画风和行云流水的打斗场面，在国内外引发轰动。B站评分高达9.9，豆瓣评分9.6，海外动漫评分网站MyAnimeList上也获得了8.9的高分。

导演林魂在采访中坦言，每一帧画面都经过精心打磨："我们想做的不是简单地模仿日式或美式动画，而是找到属于中国文化自己的动画语言。"为了实现水墨效果，团队开发了专门的渲染技术，使得画面既有传统水墨的韵味，又保持了动画的流畅性。

海外观众也纷纷给出好评。一位日本动画评论家写道："《雾山五行》证明了动画作为一种艺术形式的无限可能，它的每一帧都可以作为一幅独立的画作来欣赏。"

据悉，《雾山五行》系列将继续推出后续篇章，导演林魂表示将探索更多中国传统艺术形式与动画结合的可能性。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20animation%20style%20artwork%20depicting%20a%20martial%20arts%20warrior%20mid-action%20with%20flowing%20elemental%20powers%20dramatic%20splash%20of%20ink%20and%20fire%20swirling%20around%20the%20character%20beautiful%20blend%20of%20traditional%20Chinese%20painting&width=800&height=450&seq=article-4&orientation=landscape',
    category: '动漫',
    author: '动漫评论员',
    date: '2026-07-20',
    readTime: '4分钟',
    tags: ['雾山五行', '国漫', '水墨动画', '国产动画'],
    relatedIds: [5, 6],
  },
  {
    id: 5,
    title: '《歌手2026》首播收视破纪录 国际阵容引热议',
    excerpt: '《歌手2026》首期节目收视率突破3.5%，创下音乐综艺新纪录。本季邀请多位国际实力唱将加盟，中外歌手同台竞技看点十足。',
    content: `湖南卫视王牌音乐综艺《歌手2026》于上周五晚首播，收视率一路飙升，CSM全国网收视率达到3.52%，创下近五年音乐综艺首播收视新纪录。

本季节目最大的亮点在于国际化的选手阵容。除了那英、华晨宇、周深等国内顶级歌手外，节目组还邀请了来自美国、英国、韩国、日本的实力唱将加盟。首期节目中，英国灵魂歌手Adele的师妹Yola带来的震撼表演让全场起立鼓掌。

音乐总监梁翘柏表示："这一季我们想做的是真正的音乐无国界，让中国观众在家门口就能享受到世界级的音乐盛宴。"

华晨宇在首期节目中带来了全新改编的《齐天》，将摇滚、戏曲、电子音乐元素融为一体，获得了全场最高分。那英则选择了经典老歌《默》，深情的演绎让不少现场观众落泪。

节目播出后，"歌手2026""华晨宇齐天""那英默"等多个话题登上微博热搜。业内人士分析认为，《歌手2026》的成功证明了优质音乐内容始终有市场。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Grand%20music%20competition%20television%20stage%20with%20dramatic%20lighting%20design%20featuring%20a%20lone%20singer%20silhouette%20against%20a%20massive%20LED%20backdrop%20displaying%20cosmic%20imagery%20professional%20concert%20photography%20with%20audience%20silhouettes&width=800&height=450&seq=article-5&orientation=landscape',
    category: '综艺',
    author: '综艺观察',
    date: '2026-07-18',
    readTime: '5分钟',
    tags: ['歌手', '音乐综艺', '华晨宇', '那英'],
    relatedIds: [3, 6],
  },
  {
    id: 6,
    title: '张艺谋新作《满江红2》杀青 全明星阵容曝光',
    excerpt: '张艺谋导演新作《满江红2》近日正式杀青，沈腾、易烊千玺、雷佳音原班人马回归，更有张译、朱一龙等实力派加盟，阵容堪称豪华。',
    content: `著名导演张艺谋的最新力作《满江红2》于近日在浙江横店正式杀青。作为2023年春节档票房冠军的续作，该片自立项以来就备受关注。

影片延续了第一部的悬疑喜剧风格，但故事背景从南宋切换到了明朝嘉靖年间，围绕一桩离奇的宫廷秘案展开。张艺谋在杀青仪式上表示："《满江红2》在保持前作黑色幽默风格的同时，会加入更多的动作元素和历史厚度。"

阵容方面，沈腾、易烊千玺、雷佳音、岳云鹏等原班人马悉数回归。更令人惊喜的是，张译、朱一龙、倪妮等实力派演员也加盟了本片。据知情人士透露，张译在片中饰演一位神秘的锦衣卫指挥使，与沈腾饰演的小人物之间有着精彩的对手戏。

摄影指导赵小丁透露，本片在视觉风格上将延续第一部的高饱和度色调，但会加入更多明代的建筑美学元素："我们在横店搭建了一条完整的明代街巷，光是场景美术就花了三个月时间。"

《满江红2》预计将于2026年国庆档上映。业内人士普遍看好其票房表现，认为有望刷新国产电影票房纪录。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%20photo%20of%20acclaimed%20Chinese%20director%20Zhang%20Yimou%20directing%20actors%20on%20a%20historical%20movie%20set%20with%20elaborate%20Ming%20dynasty%20costumes%20and%20ornate%20palace%20interior%20warm%20cinematic%20lighting&width=800&height=450&seq=article-6&orientation=landscape',
    category: '电影',
    author: '电影发烧友',
    date: '2026-07-15',
    readTime: '4分钟',
    tags: ['满江红', '张艺谋', '沈腾', '国产电影'],
    relatedIds: [1, 4],
  },
];

export const articleCategories = ['全部', '电影', '电视剧', '综艺', '动漫'];